export default __webpack_public_path__ + "static/media/flower-background.c87e59e6.jpg";